const address = require('./address');

module.exports = {
    type: 'object',
    additionalProperties: false,
    properties: {
        id: {
            type: 'string'
        },
        name: {
            type: 'string'
        },
        careOfName: {
            type: 'string'
        },
        instructions: {
            type: 'string'
        },
        address: address,
        homePhone: {
            type: ['string', 'null']
        },
        phoneCountry: {
            type: ['string', 'null']
        },
        mobilePhone: {
            type: ['string', 'null']
        },
        mobilePhoneCountry: {
            type: ['string', 'null']
        },
        email: {
            type: ['string', 'null']
        }
    }
};
